import { render, staticRenderFns } from "./OrderDocumentDetails.vue?vue&type=template&id=392b28e6&scoped=true&"
import script from "./OrderDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocumentDetails.vue?vue&type=style&index=0&id=392b28e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b28e6",
  null
  
)

export default component.exports